// extracted by mini-css-extract-plugin
module.exports = {"activism-tile-item":"activism-tile-item__oQpDw","light":"light__Cad3G"};